import { useState } from 'react';
import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useGetShareableUsersList } from 'client/hooks/videoExport/useGetShareableUsers';
import { useMutateShare } from 'client/hooks/videoExport/useMutateShare';
import { RequireAdmin } from 'common/components/Auth/RequireAdmin';

export default function AddShareForm({ procedureId }: { procedureId: number }) {
    const { data, isLoading } = useGetShareableUsersList(procedureId);
    const [value, setValue] = useState<{ name: string; username: string; category: string } | null>({ name: '', username: '', category: '' });
    const [date, setDate] = useState<Date | null>(null);
    const [fullDownload, setFullDownload] = useState(false);
    const { mutate: shareVideo, isLoading: isSharing } = useMutateShare();
    const handleFullDownloadChanged = () => {
        setFullDownload(!fullDownload);
    };

    return isLoading ? (
        <Skeleton />
    ) : (
        <div>
            <Autocomplete
                disablePortal
                onChange={(event, value: { name: string; username: string; category: string } | null) => setValue(value)}
                id="users-list"
                options={data.sort(
                    (a: { name: string; username: string; category: string }, b: { name: string; username: string; category: string }) =>
                        -b.category.localeCompare(a.category)
                )}
                groupBy={option => option.category}
                getOptionLabel={option => option.name}
                sx={{ width: '100%' }}
                renderInput={params => <TextField {...params} label="Doctors, Facilities, & Users" />}
                key={data.length} // this will cause the component to re-render when the data changes
            />
            <RequireAdmin>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        name="expirationDate"
                        label="Expiration Date"
                        value={date}
                        onChange={newValue => setDate(newValue)}
                        disablePast
                        sx={{ width: '100%', mt: 2 }}
                    />
                </LocalizationProvider>
                <FormControlLabel
                    control={
                        <Checkbox name="fullDownload" required={false} checked={fullDownload} onChange={handleFullDownloadChanged} color="primary" />
                    }
                    label="Full Download"
                    style={{ width: '100%', marginTop: '2%' }}
                />
            </RequireAdmin>
            <Button
                style={{ position: 'relative', left: '56%', marginTop: '4%' }}
                onClick={() => {
                    const category = value?.category.toLowerCase() === 'user' ? 'doctor' : value?.category.toLowerCase();
                    shareVideo({
                        procedureId: procedureId,
                        shareTo: value?.username,
                        sharedType: category,
                        expirationDate: date,
                        isFullDownload: fullDownload,
                    });
                    setValue({ name: '', username: '', category: '' });
                }}
                variant="contained"
                color="primary"
                disabled={isSharing || !value?.name}
            >
                Share
            </Button>
        </div>
    );
}
